import TitleComponent from "../../components/title/Title";
import { Lady } from "../../images/Images";
import StatsCards from "./LogCards";
import LogTable from "./LogTable";
import "./PurchaseLog.css";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";

function PurchaseLog() {
  const [summary, setSummary] = useState({
    total_orders: 0,
    total_paid_orders: 0,
    total_amount_spent: 0,
    total_unique_products_purchased: 0,
  });
  const [customer, setCustomer] = useState<any>(null);
  const [orderCode, setOrderCode] = useState<string>("");
  const [orderDate, setOrderDate] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Get customer id from query string
  const searchParams = new URLSearchParams(window.location.search);
  const customerId = searchParams.get("id") || "";

  const [orders, setOrders] = useState<any[]>([]);
  useEffect(() => {
    const fetchSummary = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axiosInstance.get(`/customers/${customerId}`);
        setSummary(response.data.summary || {});
        const ordersData = response.data.orders || [];
        setOrders(ordersData);
        // Get customer info from first order if available
        if (ordersData.length > 0) {
          setCustomer(ordersData[0].customer || null);
          setOrderCode(ordersData[0].order_code || "");
          setOrderDate(ordersData[0].createdAt || "");
        }
      } catch (err: any) {
        setError(err?.response?.data?.message || "Failed to fetch summary");
      } finally {
        setLoading(false);
      }
    };
    if (customerId) {
      fetchSummary();
    }
  }, [customerId]);

  // Format amount as currency string
  const formatCurrency = (amount: number) => {
    return amount ? `$${amount.toLocaleString()}` : "$0.00";
  };

  return (
    <div className="body--container">
      <TitleComponent title="Customers" />

      <div className="purchase__log__head">
        <div className="log__profile">
          <img src={customer?.avatar || Lady} alt="image" />
          <div className="log__name">
            {loading || error
              ? "Jane Doe"
              : customer?.full_name || "Jane Doe"}
          </div>
          <div className="log__date">
            {loading || error
              ? "August 8, 2023 | PAM-66382"
              : `${orderDate ? new Date(orderDate).toLocaleDateString() : "-"} | ${orderCode || "-"}`}
          </div>
          <div className="log__status">
            <span></span> {loading || error ? "Active" : customer?.membership_type || "Active"}
          </div>
        </div>
      </div>

      <div className="log__tables">
        <StatsCards
          completedPurchases={loading || error ? 0 : orders.filter((o) => o.status === "delivered").length}
          ongoingPurchases={loading || error ? 0 : summary.total_orders - (orders.filter((o) => o.status === "delivered").length)}
          closedClaims={0}
          totalAmountSpent={loading || error ? "$0.00" : formatCurrency(summary.total_amount_spent)}
          totalCreditBalance={loading || error ? "$0.00" : formatCurrency(summary.total_amount_spent)}
        />

        <div>
          <h4 style={{ color: "#5E5D5D" }}>Purchase Logs</h4>
          <LogTable />
        </div>
      </div>
    </div>
  );
}

export default PurchaseLog;
